<template>
  <div class="sc-chat-window w-100 flex flex-col justify-between bg-white">
    <div class="flex flex-col h-full overflow-auto">
      <ChatHeader :theme-config="themeConfig"
                  :lang-config="langConfig"
                  :header-logo-cache="imageCache.headerLogo"
      />
      <ChatStatus v-if="selectedChatPreview !== CHAT_ELEMENTS.carousel"
                  :theme-config="themeConfig"
      />
      <div class="flex flex-col gap-4 overflow-auto p-4 flex-1"
           :style="{ background: themeConfig.messageList.bg }"
      >
        <component v-for="(message, i) in messageList"
                   :is="message.component"
                   :key="i"
                   :theme-config="themeConfig"
                   v-bind="message.props"
        />
      </div>
    </div>

    <div class="flex w-full flex-col border">
      <ChatControls :theme-config="themeConfig"
                    :show-file="selectedChatPreview === CHAT_ELEMENTS.file"
      />
    </div>
  </div>
</template>

<script>
import BotMessage from '@/components/settings/bot-theme/chat-widget/components/messages/BotMessage.vue'
import CarouselMessage from '@/components/settings/bot-theme/chat-widget/components/messages/CarouselMessage.vue'
import ChatControls from '@/components/settings/bot-theme/chat-widget/components/chat/ChatControls.vue'
import ChatFooter from '@/components/settings/bot-theme/chat-widget/components/chat/ChatFooter.vue'
import ChatHeader from '@/components/settings/bot-theme/chat-widget/components/chat/ChatHeader.vue'
import ChatStatus from '@/components/settings/bot-theme/chat-widget/components/chat/ChatStatus.vue'
import ClientMessage from '@/components/settings/bot-theme/chat-widget/components/messages/ClientMessage.vue'
import FileMessage from '@/components/settings/bot-theme/chat-widget/components/messages/FileMessage.vue'
import InputMessage from '@/components/settings/bot-theme/chat-widget/components/messages/InputMessage.vue'
import QRMessage from '@/components/settings/bot-theme/chat-widget/components/messages/QRMessage.vue'
import { CHAT_ELEMENTS } from '@/constants/chat-theme.constants'

export default {
  name: 'ChatWidget',

  components: {
    ChatStatus,
    ChatHeader,
    ChatControls,
    ChatFooter
  },

  props: {
    selectedChatPreview: {
      type: String,
      required: true
    },
    themeConfig: {
      type: Object,
      required: true
    },
    langConfig: {
      type: Object,
      required: true
    },
    imageCache: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      CHAT_ELEMENTS,
      messageListMap: {
        [CHAT_ELEMENTS.quickReplies]: [
          { component: BotMessage },
          { component: QRMessage }
        ],
        [CHAT_ELEMENTS.buttons]: [
          { component: BotMessage, props: { text: 'How can I help?' } },
          { component: ClientMessage, props: { text: 'I lost keys!' } },
          { component: BotMessage, props: { showButton: true, text: 'Contact us!' } }
        ],
        [CHAT_ELEMENTS.clientInput]: [
          {
            component: BotMessage,
            props: { text: 'Leave us your email, and we will contact you as soon as possible!' }
          },
          { component: InputMessage }
        ],
        [CHAT_ELEMENTS.carousel]: [
          { component: BotMessage, props: { text: 'I have found products for you!' } },
          { component: CarouselMessage }
        ],
        [CHAT_ELEMENTS.fileAttachment]: [
          { component: BotMessage, props: { text: 'Please fill the form below.!' } },
          { component: FileMessage, props: { sent: true, direction: 'received' } },
          { component: FileMessage }
        ]
      }
    }
  },

  computed: {
    messageList() {
      return this.messageListMap[this.selectedChatPreview]
    }
  }
}
</script>

